module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"Grid_Research_Price_And_Sponsor":"თანხა/სპონს.","Grid_Research_Payment_And_Debt":"გადახ/ვალი","Grid_Research_Info_Services_Service":"სერვისი","Grid_DoctorReceive_Insurance":"სადაზღვევო"},"en":{}}')
  delete Component.options._Ctor
}
